<template>
  <!-- Error page-->
  <div class="sf-misc-page">
    <div class="sf-misc-glow-a" />
    <div class="sf-misc-glow-b" />

    <div class="sf-misc-container">
      <b-link class="sf-misc-logo hidden">
        <vuexy-logo />
        <h2 class="sf-misc-brand">
          Crytoboot
        </h2>
      </b-link>

      <div class="sf-misc-card">
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
          class="sf-misc-illustration"
        />
        <h2 class="sf-misc-title">
          Página não encontrada
        </h2>
        <p class="sf-misc-text">
          Oops! The requested URL was not found on this server.
        </p>

        <b-link
          class="sf-misc-btn"
          :to="getLinkHome"
        >
          Voltar para home
        </b-link>
      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getLinkHome } from '@/auth/utils'

export default {
  components: {
    VuexyLogo,
    BLink,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {

    getLinkHome() {
      return getLinkHome()
    },

    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss" scoped>
/* ============================================================
   Páginas "misc" (404 / não autorizado / manutenção) — Soulf.
   ============================================================ */
.sf-misc-page {
  min-height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  font-family: 'Geist', sans-serif;
}
.sf-misc-glow-a {
  position: absolute; width: 520px; height: 520px; border-radius: 50%;
  background: rgba(37, 99, 235, 0.08); filter: blur(90px);
  top: -160px; right: -120px; pointer-events: none;
}
.sf-misc-glow-b {
  position: absolute; width: 420px; height: 420px; border-radius: 50%;
  background: rgba(37, 99, 235, 0.06); filter: blur(90px);
  bottom: -140px; left: -100px; pointer-events: none;
}
.sf-misc-container { width: 100%; max-width: 460px; position: relative; z-index: 1; }

.sf-misc-logo {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  margin-bottom: 24px; text-decoration: none;
  &.hidden { display: none !important; }
}
.sf-misc-brand { font-size: 17px; font-weight: 600; color: #fff !important; margin: 0; }

.sf-misc-card {
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 20px;
  padding: 40px 34px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  }
}
.sf-misc-illustration { max-width: 220px; width: 100%; margin: 0 auto 24px; }
.sf-misc-title { font-size: 20px; font-weight: 600; color: #fff; margin: 0 0 8px; }
.sf-misc-text { font-size: 13.5px; color: rgba(255, 255, 255, 0.55); line-height: 1.5; margin: 0 0 24px; }
.sf-misc-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: none; background: #3b82f6; color: #fff !important;
  font-family: 'Geist', sans-serif; font-weight: 600; font-size: 13.5px;
  padding: 11px 26px; border-radius: 9999px; cursor: pointer;
  box-shadow: 0 0 32px rgba(59, 130, 246, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transition: transform .15s ease;
  text-decoration: none;

  &:hover { transform: translateY(-2px); color: #fff !important; text-decoration: none; }
}
</style>
